import React from 'react';
import {useTranslation} from 'next-i18next';
import {
	Button,
	DarkMode,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@tempo/core';

type DeleteClaimModalProps = {
	isOpen: boolean;
	onDelete: () => void;
	onClose: () => void;
};

const DeleteClaimModal = ({
	isOpen,
	onClose,
	onDelete,
}: DeleteClaimModalProps) => {
	const {t} = useTranslation('d4c');
	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<DarkMode>
				<ModalContent data-theme="dark" color="text.neutral.primary.default">
					<ModalHeader>
						{t('toastmessage_title_youwanttodeletethisrequest_d4c-web')}
					</ModalHeader>
					<ModalCloseButton data-testid="modal-close-button" />
					<ModalBody>
						<Text
							color="text.neutral.secondary.default"
							variant="body.default.regular"
						>
							{t('toastmessage_text_thisactioncannotbeundone_d4c-web')}
						</Text>
					</ModalBody>

					<ModalFooter>
						<Button
							data-testid="modal-cancel-button"
							onClick={onClose}
							variant="ghost"
						>
							{t('generic_action_cancel_d4c-web')}
						</Button>
						<Button data-testid="modal-delete-button" onClick={onDelete}>
							{t('generic_action_delete_d4c-web')}
						</Button>
					</ModalFooter>
				</ModalContent>
			</DarkMode>
		</Modal>
	);
};

export default DeleteClaimModal;
